import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { Box, Flex } from "rebass/styled-components";
import { HiExclamationCircle } from "react-icons/hi";

import { useUnsavedDraftCount } from "MVVM/Hooks/useUnsavedDraftCount";

export const UnsavedDraftsBubble = () => {
  const unsavedCount = useUnsavedDraftCount();
  const history = useHistory();
  const location = useLocation();
  const [dismissed, setDismissed] = React.useState(false);

  const isLibraryPage = location.pathname === "/library";

  if (!unsavedCount || dismissed || isLibraryPage) {
    return null;
  }

  return (
    <BubbleContainer
      onClick={() => history.push("/library")}
      role="button"
      tabIndex={0}
    >
      <BubbleIcon>
        <HiExclamationCircle size={20} />
      </BubbleIcon>
      <BubbleText>
        {unsavedCount} unsaved draft{unsavedCount !== 1 ? "s" : ""} expiring
        soon
      </BubbleText>
      <DismissButton
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          setDismissed(true);
        }}
      >
        ✕
      </DismissButton>
    </BubbleContainer>
  );
};

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% {
    box-shadow: 2px 10px 30px #10181d, 0 0 0 0 rgba(239, 68, 68, 0.3);
  }
  50% {
    box-shadow: 2px 10px 30px #10181d, 0 0 0 4px rgba(239, 68, 68, 0);
  }
`;

const BubbleContainer = styled(Flex)`
  align-items: center;
  animation:
    ${slideIn} 0.3s ease-out,
    ${pulse} 2.5s ease-in-out infinite 0.3s;
  background: ${({ theme }) => theme.colors.ned};
  border: 1px solid ${({ theme }) => theme.colors.alert};
  border-radius: 999px;
  cursor: pointer;
  gap: 8px;
  padding: 8px 12px 8px 12px;
  transition:
    border-color 0.2s,
    transform 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.alert};
    transform: scale(1.02);
  }
`;

const BubbleIcon = styled(Flex)`
  align-items: center;
  color: ${({ theme }) => theme.colors.alert};
`;

const BubbleText = styled(Box)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`;

const DismissButton = styled(Flex)`
  align-items: center;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.shade400};
  cursor: pointer;
  font-size: 12px;
  height: 20px;
  justify-content: center;
  transition: color 0.15s ease;
  width: 20px;

  &:hover {
    color: ${({ theme }) => theme.colors.ice};
  }
`;
